var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import { ZapCard } from '../ZapCard';
import { labelStyles, isolateComponent } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme';
const breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const Styles = labelStyles('ZapCardSection', {
    root: css `
    padding: 20px;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      padding: 20px 30px;
    }

    @media screen and (min-width: ${breakpoints.desktop}px) {
      padding: 40px;
    }
  `,
    container: (layout) => css `
    display: grid;
    gap: 30px;
    grid-template-columns: ${layout === 'auto'
        ? '1fr'
        : 'repeat(auto-fit, minmax(235px, 1fr))'};
    margin: 0 auto;
    max-width: 1170px;
  `,
});
export const ZapCardSection = ({ items, layout = 'card' }) => {
    var _a;
    if (items.length > 3 && layout !== 'auto') {
        console.error('Max 3 items are allowed in ZapCardSection component');
    }
    const maxItems = layout === 'auto' ? items.length : 3;
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("div", { css: Styles.container(layout) }, (_a = items === null || items === void 0 ? void 0 : items.slice(0, maxItems)) === null || _a === void 0 ? void 0 : _a.map((_a) => {
            var { color = Colors.neutral100, href } = _a, rest = __rest(_a, ["color", "href"]);
            return (isolateComponent(ZapCard, Object.assign({}, rest, { color: color, href: href, layout: layout })));
        }))));
};
//# sourceMappingURL=ZapCardSection.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
